export enum OrderType {
  PREORDER = 'preorder',
  STANDARD = 'standard',
  TERMINAL = 'terminal',
  VIRTUAL = 'virtual',
}
